var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Footer',{staticClass:"app-footer"},[_c('p',[_vm._v("© 2023 亚信科技（中国）有限公司 版权所有")])])
}
var staticRenderFns = []

export { render, staticRenderFns }